import { PageLocatorMap } from '../types/PageLocatorMap';

export const applySearchVinPage = {
  footer: {
    root: 'apply-search-vin-page.footer.root',
  },
  form: {
    h1: 'apply-search-vin-page.form.h1',
    h2: 'apply-search-vin-page.form.h2',
    root: 'apply-search-vin-page.form.root',
    submitButton: 'apply-search-vin-page.form.submit-button',
    vinInput: 'apply-search-vin-page.form.vin-input',
    vinInputError: 'apply-search-vin-page.form.vin-input-error',
  },
  header: {
    drawerButton: 'apply-search-vin-page.header.drawer-button',
    previousStepButton: 'apply-search-vin-page.header.previous-step-button',
    root: 'apply-search-vin-page.header.root',
  },
  progress: {
    root: 'apply-search-vin-page.progress.root',
  },
} as const satisfies PageLocatorMap;
